module.exports = __webpack_public_path__ + "media/markers/marker-transparent-indigo-d2b9852f.svg";